import React from "react";

// Interlocked B + O monogram: negative space between the B stem and the O
// forms a triangular roofline / peak.
export const LogoMark = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    className={`block shrink-0 ${className}`}
    aria-hidden="true"
  >
    <rect x="2" y="2" width="60" height="60" stroke="#2B2B2B" strokeWidth="3" />
    {/* Roofline peak (negative space between the B and O) */}
    <path
      d="M12 38 L32 14 L52 38"
      stroke="#C68B4E"
      strokeWidth="5"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
    {/* B + O baseline: two supporting strokes forming the letterforms' feet */}
    <path d="M18 38 L18 50" stroke="#2B2B2B" strokeWidth="5" strokeLinecap="square" />
    <path d="M46 38 L46 50" stroke="#2B2B2B" strokeWidth="5" strokeLinecap="square" />
    <path d="M18 50 L46 50" stroke="#7A8B6F" strokeWidth="4" strokeLinecap="square" />
  </svg>
);

export const Logo = ({ light = false, compact = false }) => (
  <div className="inline-flex items-center gap-2.5">
    <LogoMark size={compact ? 34 : 42} />
    {!compact && (
      <div className="flex flex-col justify-center leading-none">
        <span
          className="font-extrabold tracking-tight text-[1.05rem] sm:text-[1.15rem]"
          style={{ color: light ? "#F7F3EC" : "#2B2B2B" }}
        >
          Bright Oak
        </span>
        <span
          className="font-bold uppercase text-[0.55rem] tracking-[0.28em]"
          style={{ color: "#C68B4E", marginTop: "4px", marginRight: "-0.28em" }}
        >
          Renovations
        </span>
      </div>
    )}
  </div>
);
